import React from 'react';
import PropTypes from 'prop-types';

import PlanSelect from '../PlanSelect';
import Spacing from '../Spacing';
import Tabs from '../Tabs';

import isFeatureFlagEnabled from '../../helpers/feature-flags';

const PhoneDetailsPlanSelect = ({
  planGroups,
  selectedPlanGroupName,
  onChange
}) => {
  // Prepare options for PlanSelect
  const planGroupOptions = planGroups
    .filter(({ enabledOnPhoneDetail }) => enabledOnPhoneDetail)
    .map(group => {
      const { groupName, groupDisplayName, shortDescription } = group;

      return {
        ...group,
        text: groupDisplayName || groupName,
        icon: null,
        value: groupName,
        description: shortDescription
      };
    });

  const selectedPlanGroup = planGroupOptions.find(
    pg => pg.groupName === selectedPlanGroupName
  );

  // If there is only one option, we dont show PlanSelect at all
  if (planGroupOptions.length < 2) {
    return null;
  }

  let renderPlanGroupSelect = null;
  let renderPlanGroupDescription = null;
  if (isFeatureFlagEnabled('PLAN_GROUP_TABS')) {
    renderPlanGroupSelect = (
      <Spacing top={1} topMd={3} bottom={4} bottomMd={5}>
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          items={planGroupOptions}
          selectedTab={selectedPlanGroup.value}
          onTabChange={onChange}
        />
      </Spacing>
    );

    renderPlanGroupDescription = (
      <Spacing bottom={2} bottomMd={2}>
        {selectedPlanGroup.description}
      </Spacing>
    );
  } else {
    renderPlanGroupSelect = (
      <Spacing bottom={2}>
        <PlanSelect
          items={planGroupOptions}
          selectedItem={selectedPlanGroup}
          onSelectChange={onChange}
        />
      </Spacing>
    );
  }

  return (
    <>
      {renderPlanGroupSelect}
      {renderPlanGroupDescription}
    </>
  );
};

PhoneDetailsPlanSelect.propTypes = {
  planGroups: PropTypes.array,
  selectedPlanGroupName: PropTypes.string,
  onChange: PropTypes.func
};

export default PhoneDetailsPlanSelect;
